import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BannerService } from '../services/banner.service';
import { SesionService } from '../services/sesion.service';


@Component({
  selector: 'banner-dhl',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent {
  message: string;
  private tableBannersLanguage = new Map<string, string>();
  constructor(bannerService: BannerService,
    sesion: SesionService,
    cdr: ChangeDetectorRef) {
    sesion.idioma$.subscribe(idioma => {
      if (!idioma) {
        return;
      }
      if (this.tableBannersLanguage.has(idioma)) {
        this.message = this.tableBannersLanguage.get(idioma);
        cdr.detectChanges();
      } else {
        if (!sesion.fechaFinMantenimiento || sesion.fechaFinMantenimiento < new Date()) {
          bannerService.banner().subscribe(message => {
            this.tableBannersLanguage.set(idioma, message);
            this.message = message;
            cdr.detectChanges();
          }, err => {
            console.error(err);
          });
        }
      }
    });
  }
}
